module.exports = __webpack_public_path__ + "img/ce3962ef0182dae96fbe9f7b79de7728.png";